// Description: Final step of the verify email process
// Updated: 20/08/2025
// Author: Simon Franklin

// React
import React from 'react';
import { useNavigate } from 'react-router-dom';

// Material UI Components
import { Stack, Button, Typography } from '@mui/material';

// Render The Component
const FinalStep = () => {
    const navigate = useNavigate();

    const handlePanel = () => {
        window.location.pathname = '/';
    };

    return (
        <Stack spacing={2} useFlexGap>
            <Typography variant="h1">✅</Typography>
            <Typography variant="h5">Seu e-mail foi verificado!</Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                Clique no botão abaixo para ir ao painel inicial.
            </Typography>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ width: '100%' }}>
                <Button variant="outlined" sx={{ width: { xs: '100%', sm: 'auto' } }} onClick={handlePanel}>
                    Ir para o painel
                </Button>
            </Stack>
        </Stack>
    );
};

export default FinalStep;
